<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="البحث"
                  single-line
                  hide-details
                  class="centered-input"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="Items"
                :search="search"
                :sort-by="['name']"
                class="elevation-12"
                dense
                :footer-props="{
                'items-per-page-options':[10,15,20,25],
                }"
                item-key="ID"
                height="63vh"
                :loading="loading"
                loading-text="جارٍ التحميل..."
              >
                  <template v-slot:item.name="{ item }">
                  <div class="truncate-column">
                   {{ item.name }}
                   </div>
              </template>
                <template v-slot:item.actions="{ item }">
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="1">
                        <v-btn x-small fab @click="DecrementItem(item)"
                          ><b style="font-size: large;">-</b></v-btn
                        >
                      </v-col>
                      <v-col cols="5"
                        ><v-text-field
                          rounded
                          dense
                          filled
                          v-model="item.qty"
                          label=""
                          @keydown="checkKeyDownAlphaNumeric($event)"
                          @keydown.enter="AddItemToCart(item)"
                          type="number"
                          hide-spin-buttons
                          hide-details=""
                          class="centered-input text--darken-3 ml-3"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="1">
                        <v-btn
                          class="ml-4"
                          x-small
                          fab
                          @click="IncrementItem(item)"
                          ><b style="font-size: large;">+</b></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:item.Order="{ item }">
                  <v-btn
                    color="blue-grey darken-1"
                    dark
                    rounded
                    small
                    @click="AddItemToCart(item)"
                    ><v-icon>mdi-cart</v-icon> اضافة الى السلة</v-btn
                  >
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar"
          :timeout="timeout"
          color="green"
        >
          تم اضافة المادة بنجاح
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar1"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar0"
          :timeout="timeout"
        >
          المادة تم اضافتها سابقا الى السلة
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar2"
          :timeout="timeout"
        >
          الكمية لا يمكن ان تكون تحت الصفر او تساويه
        </v-snackbar>
        <v-snackbar
          transition="fade-transition"
          v-model="snackbar3"
          :timeout="timeout"
        >
          الحد المسموح للفاتورة الواحدة هو 60 مادة
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ItemsTable",

  data() {
    return {
      timeout: 1700,
      snackbar: false,
      snackbar0: false,
      snackbar1: false,
      snackbar2: false,
      snackbar3: false,
      loading: true,
      search: "",
      GotedItems: [],
      Items: [],
      headers: [
        { text: "اسم المادة", value: "name" },
        { text: "", value: "actions", align: "start" },
        { text: "", value: "Order" },
      ],
    };
  },

  created() {
    const baseURI = "https://erp.matein3.com/api/Item/List";
    this.$axios.get(baseURI).then((result) => {
      this.EditItems(result.data.data);
      this.loading = false;
    });
  },

  methods: {
    EditItems(data) {
      this.GotedItems = data;
      this.GotedItems.forEach((element) => {
        const tempObj = {
          id: element.id,
          name: element.name,
          qty: "",
        };
        this.Items.push(tempObj);
      });
    },
    IncrementItem(item) {
      if (item.qty === "") {
        item.qty = 1;
      } else {
        item.qty = parseInt(item.qty);
        this.Items.forEach((element) => {
          if (item === element) element.qty++;
        });
      }
    },
    DecrementItem(item) {
      if (item.qty == 0) {
        this.snackbar1 = true;
      } else {
        item.qty = parseInt(item.qty);
        this.Items.forEach((element) => {
          if (item === element) element.qty--;
        });
      }
    },
    OnItemCountChange(item) {
      if (item.qty < 0) {
        item.qty = "";
        this.snackbar1 = true;
      }
    },
    checkKeyDownAlphaNumeric(event) {
      if (event.key === "Backspace") {
      } else if (!/^[0-9]\d*$/.test(event.key)) {
        this.ignoredValue = event.key ? event.key : "";
        event.preventDefault();
      }
    },
    AddItemToCart(item) {
      if (item.qty <= 0) {
        item.qty = "";
        this.snackbar2 = true;
      } else {
        item.qty = parseInt(item.qty);
        this.Items.forEach((element) => {
          if (item === element) {
            this.$store.dispatch("AddNewItem", item).then((data) => {
              console.log(data)
              if (data === 1) this.snackbar0 = true;
              if (data === 2) this.snackbar3 = true;
              else this.snackbar = true;
            });
            this.search = "";
            item.qty = "";
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.truncate-column {
  max-width: 550px;
}
</style>